import AutoBind from 'auto-bind'
import EventEmitter from 'events'
import Prefix from 'prefix'
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

import Text from '../animations/Text'
import Paragraph from '../animations/Paragraph'

import OverflowScrollLoop from '../components/OverflowScrollLoop'
import ScrollButtons from '../components/ScrollButtons'
import ReturnToTopButton from '../components/ReturnToTopButton'
import HeaderColour from '../components/HeaderColour'

import Detection from '../classes/Detection'

import { mapEach } from '../utils/dom'
import { setElHeightVariables } from '../utils/setElHeightVariables'

import each from 'lodash/each'

export default class extends EventEmitter {
  constructor ({ classes, element, elements, isScrollable = true }) {
    super()

    // AutoBind(this)

    this.classes = {
      ...classes
    }

    this.selectors = {
      element,
      elements: {
        animationsTexts: '[data-animation="text"]',
        animationsParagraphs: '[data-animation="paragraph"]',

        ...elements
      }
    }

    this.isScrollable = isScrollable

    this.transformPrefix = Prefix('transform')

  }

  create () {
    this.animations = []

    this.element = document.querySelector(this.selectors.element)
    this.elements = {}

    each(this.selectors.elements, (selector, key) => {
      if (selector instanceof window.HTMLElement || selector instanceof window.NodeList) {
        this.elements[key] = selector
      } else if (Array.isArray(selector)) {
        this.elements[key] = selector
      } else {
        this.elements[key] = this.element.querySelectorAll(selector)

        if (this.elements[key].length === 0) {
          this.elements[key] = null
        } else if (this.elements[key].length === 1) {
          this.elements[key] = this.element.querySelector(selector)
        }
      }
    })

    if (this.isScrollable) {
      this.scroll = {
        ease: 0.07,
        position: 0,
        current: 0,
        target: 0,
        limit: 0
      }
    }


    this.createAnimations()
    setElHeightVariables()

    this.overflowScrollLoop = new OverflowScrollLoop()
    this.scrollButtons = new ScrollButtons()
    this.returnToTopButton = new ReturnToTopButton()
    this.headerColour = new HeaderColour()

  }

  setScrollPos(scrollTo, scrollHistory, timing = 0, animation = new gsap.timeline({ defaults: { ease: "circ.easeIn" } })) {
    let scrollHistoryItem = scrollHistory.positions.find(x => x.id == window.location.href)
    let scrollHistoryPosition = scrollHistoryItem ? scrollHistoryItem.position : 0

    let y = scrollTo.y
    let offsetY = scrollTo.offsetY

    let scrollToPos = scrollHistory.scrollToSavedPosition ? scrollHistoryPosition : y

    animation
    .to(window, timing, {
      scrollTo: {
        y: scrollToPos,
        offsetY: offsetY
      },
    })
  }

  /**
   * Animations.
   */
  createAnimations () {
    this.animationsTexts = mapEach(this.elements.animationsTexts, element => {
      return new Text({ element })
    })

    this.animations.push(...this.animationsTexts)

    console.log('this.animationsTexts', this.animationsTexts)

    this.animationsParagraphs = mapEach(this.elements.animationsParagraphs, element => {
      return new Paragraph({ element })
    })

    this.animations.push(...this.animationsParagraphs)
    console.log('this.animationsParagraphs', this.animationsParagraphs)

    // marqueeButtons
    if (document.querySelector('[data-marquee-button]')) {
      import(
        '../elements/ButtonMarquee.js' /* webpackChunkName: "elements/buttonMarquee'" */
      ).then((MarqueeButton) => {
        this.marqueeButtons = new MarqueeButton.default();
      })
    }

  }  

  async show (animation = new gsap.timeline()) {
    console.log('Show BASE function', this.element)
    return new Promise(resolve => {
      animation.call(() => {
        resolve()
      })

      this.addEventListeners()
    })

  }

  async hide (animation = new gsap.timeline({})) {
    console.log('Hide BASE function')
    return new Promise(resolve => {
      animation.call(() => {
        resolve()
      })
    })
  }

  animateOut () {
    this.animations.forEach(animation => {
      animation.animateOut()
    })
  }

  /**
   * Events.
   */
  onResize () {
    if (!this.isScrollable || !this.elements.wrapper) return

    this.scroll.limit = this.elements.wrapper.clientHeight - window.innerHeight

    this.update()

    this.animations.forEach(animation => {
      animation.onResize && animation.onResize()
    })
  }

  onTouchDown (event) {
    if (!Detection.isPhone()) return

    this.isDown = true

    this.scroll.position = this.scroll.current
    this.start = event.touches ? event.touches[0].clientY : event.clientY
    console.log('Page onTouchDown')
  }

  onTouchMove (event) {
    if (!Detection.isPhone() || !this.isDown) return

    const y = event.touches ? event.touches[0].clientY : event.clientY
    const distance = (this.start - y) * 3

    this.scroll.target = this.scroll.position + distance
  }

  onTouchUp (event) {
    if (!Detection.isPhone()) return

    this.isDown = false
    console.log('Page onTouchUp')
  }

  onWheel (normalized) {
    const speed = normalized.pixelY

    this.scroll.target += speed

    return speed
  }

  reset () {

  }

  /**
   * Listeners.
   */
  addEventListeners () {

  }

  removeEventListeners () {
    
  }

  /**
   * Destroy.
   */
  destroy () {
    if (document.querySelector('[data-marquee-button]') && this.marqueeButtons)  {
      this.marqueeButtons.destroy()
    }

    if (document.querySelector('[data-overflow-scroll]')) {
      this.overflowScrollLoop.destroy()
    }

    if (document.querySelector('[data-scroll-button]')) {
      this.scrollButtons.destroy()
    }

    if (document.querySelector('[data-top-button]')) {
      this.returnToTopButton.destroy()
    }

    if (document.querySelector('[data-header-invert]')) {
      this.headerColour.destroy()
    }

  }

  /**
   * Frames.
   */
  update () {
    
    // this.scroll.target = clamp(0, this.scroll.limit, this.scroll.target)

    // this.scroll.current = lerp(this.scroll.current, this.scroll.target, this.scroll.ease)
    // this.scroll.current = Math.floor(this.scroll.current)

    // if (this.scroll.current < 0.1) {
    //   this.scroll.current = 0
    // }

    // if (this.elements.wrapper) {
    //   this.transform(this.elements.wrapper, this.scroll.current)
    // }

    // each(this.animations, animation => {
    //   animation.update && animation.update(this.scroll)
    // })

    // this.scroll.last = this.scroll.current
  }  
}
